<template>
    <div class="dt-course-video-info-list" style="padding: 80px;">
        <div class="dt-course-video-main">
            <div class="dt-course-video-main-title">
                <Avatar :src="userHeadImg" style="background: #619fe7;margin-right: 10px;float:left;"
                        size="large"></Avatar>
                <p style="padding-top: 10px;">教师{{activeTeaUseAddTimeList[0].fullName}}</p>
            </div>
            <div class="dt-course-video-main-content">
                <Timeline class="dt-course-video-main-timeline">
                    <Scroll :on-reach-bottom="handleReachBottom" :height="recordHeight">
                    <TimelineItem class="dt-course-video-main-timeline-item"
                                  v-for="item in activeTeaUseAddTimeList" :key="item.rowNum">
                        <i class="dt-course-video-main-timeline-item-icon" slot="dot"></i>
                        <div class="dt-course-video-main-timeline-item-time">
                            {{item.create_time.split(' ')[0].substring(5)+"-"+item.create_time.split(' ')[1]}}
                        </div>
                        <div class="dt-course-video-main-timeline-item-box">
                            <span class="dt-course-video-main-timeline-item-box-left-arrow"></span>
                            <div class="dt-course-video-main-timeline-item-box-info">
                                <div class="dt-course-video-main-timeline-item-box-info-content">
                  <span class="dt-course-video-main-timeline-item-box-info-content-explan"
                        v-if="item.dynamic_data.length>0">
                    <span
                        class="dt-course-video-main-timeline-item-box-info-content-module-name">{{item.funcName}}</span>
                    •使用{{item.clsName}}•{{item.dynamic_data}}
                  </span>
                                    <span class="dt-course-video-main-timeline-item-box-info-content-explan"
                                          v-else>
                    <span
                        class="dt-course-video-main-timeline-item-box-info-content-module-name">{{item.funcName}}</span>
                    •使用{{item.clsName}}
                  </span>
                                </div>
                            </div>
                        </div>
                    </TimelineItem>
                    </Scroll>
                </Timeline>
            </div>
        </div>
    </div>
</template>

<script>
    import {getSchoolTeacherByIdList} from "../../../../service/api.js";
    import {mapGetters} from 'vuex'

    export default {
        name: "user-detail-record",
        computed: {
            ...mapGetters([
                'userHeadImg'
            ])
        },
        data () {
            return {
                activeTeaUseAddTimeList: [],
                page: 1,
                total: 0,
                limit: 10,
                pageCount: 0,
                recordHeight:"0px"
            }
        },
        methods: {
            /**
             *获取活跃教师使用详情（带时间）
             */
            async queryActiveTeaUseAddTime () {
                let _this = this;
                let params = {
                    schoolId: "zbzqao6l35hdtwjut9hmmg",
                    startTime: "2019-12-01",
                    endTime: "2019-12-31",
                    userId: "cf16360749cc48eb8ad250dc0f1ea3ca",
                    proKey: -1,
                    keyWord: "",
                    page: _this.page,
                    limit: 30
                };
                await getSchoolTeacherByIdList(params)
                    .then(function (data) {
                        let resultDate = data.rows;
                        for (let i = 0; i < resultDate.length; i++) {
                            _this.activeTeaUseAddTimeList.push(resultDate[i]);
                        }
                        _this.total = data.total_rows;
                        _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            handleReachBottom () {
                let _this = this;
                _this.page++;
                return new Promise(resolve => {
                    setTimeout(() => {
                        _this.queryActiveTeaUseAddTime();
                        resolve();
                    }, 2000);
                });
            }
        },
        mounted () {
            let _this=this;
            // 获取活跃教师使用详情
            _this.queryActiveTeaUseAddTime();
            //计算高度
            _this.$nextTick(()=>{
                _this.recordHeight=window.innerHeight-125+'px';
            })
        }
    }
</script>

<style lang="scss" scoped>

</style>
<style lang="scss">
    .dt-course-video-main-timeline .ivu-timeline-item-tail {
        top: 38px !important;
        left: 8.5px !important;
    }

    .dt-course-video-main-timeline .ivu-timeline-item-head {
        width: 19px !important;
        height: 19px !important;
    }

    .dt-course-video-main-timeline .ivu-timeline-item-content {
        padding: 0px 1px 10px 45px !important;
        font-size: 16px !important;
    }

    .dt-course-video-main-timeline .ivu-timeline-item {
        padding: 0 0 50px 0 !important;
    }

    .dt-course-video-main-timeline .ivu-timeline-item-tail {
        border-left: 2px dashed #93d0f8 !important;
    }

    .dt-course-video-main-timeline .ivu-timeline-item-head-custom {
        left: 0 !important;
        margin-top: 43px !important;
    }

    .dt-course-video-main-timeline .ivu-timeline-item:last-child .ivu-timeline-item-tail {
        display: block !important;
    }
    .dt-course-video-info-list{
        ::-webkit-scrollbar {
            width: 0 !important;
        }
    }

</style>
